module.exports = __webpack_public_path__ + "img/banner1.3d0278e9.png";